var _circle, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPendingTransaction(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 28,
    cy: 28,
    r: 28,
    fill: "#F4F7FE"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_642_474)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.5204 21.7458C25.8396 21.7561 24.5148 20.5066 24.4982 18.8963C24.4816 17.3029 25.8191 16.0047 27.4823 16C29.1505 15.9953 30.4967 17.2673 30.5084 18.8598C30.5201 20.4579 29.1973 21.7355 27.5214 21.7458H27.5204Z",
    fill: "#6F7CED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.5234 24.4022C19.0163 24.42 17.75 23.2193 17.7442 21.7665C17.7383 20.3389 18.9587 19.1448 20.4581 19.1101C21.9546 19.0754 23.2266 20.264 23.2579 21.7271C23.2891 23.1734 22.0511 24.3844 20.5244 24.4022H20.5234Z",
    fill: "#6F7CED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.9841 28.4661C19.989 29.8018 18.8632 30.8947 17.4936 30.8863C16.1425 30.8778 15.0118 29.7943 15.0001 28.4952C14.9874 27.1726 16.1229 26.0872 17.5111 26.0938C18.9081 26.1003 19.9792 27.1286 19.9841 28.4652V28.4661Z",
    fill: "#6F7CED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.5211 33.0567C21.7639 33.0613 22.7355 34.0005 22.7375 35.1975C22.7394 36.3944 21.7122 37.3824 20.482 37.3683C19.2626 37.3543 18.2617 36.3813 18.2578 35.2059C18.253 33.9977 19.2499 33.052 20.5211 33.0567Z",
    fill: "#6F7CED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.5088 36.1621C28.5926 36.1659 29.4852 37.0207 29.4998 38.0677C29.5144 39.1222 28.5974 40.0042 27.4912 40.0014C26.3771 39.9976 25.5079 39.1372 25.5196 38.0517C25.5314 36.9991 26.4162 36.1584 27.5078 36.163L27.5088 36.1621Z",
    fill: "#6F7CED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.759 35.1641C32.7726 34.2465 33.555 33.5238 34.5237 33.5313C35.467 33.5397 36.264 34.3149 36.2514 35.2147C36.2397 36.1108 35.4212 36.8888 34.4935 36.8869C33.5316 36.885 32.7443 36.1033 32.758 35.1641H32.759Z",
    fill: "#6F7CED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.5154 27.0547C38.3417 27.0603 39.0041 27.6987 39.0002 28.4851C38.9963 29.2762 38.3349 29.9032 37.5028 29.907C36.654 29.9107 35.9722 29.2518 35.9926 28.4495C36.0131 27.6621 36.6833 27.0491 37.5154 27.0547Z",
    fill: "#6F7CED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.4782 22.9443C33.7924 22.9368 33.2471 22.4091 33.25 21.7539C33.2529 21.0846 33.8256 20.5625 34.5397 20.5785C35.2294 20.5935 35.762 21.1296 35.7425 21.7895C35.723 22.4522 35.1767 22.9508 34.4782 22.9443Z",
    fill: "#6F7CED"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_642_474"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(15 16)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPendingTransaction);
export default __webpack_public_path__ + "static/media/pending-transaction.6a1a93c1.svg";
export { ForwardRef as ReactComponent };